import {
  IChangePasswordUserData,
  IUpdateUserEmailData,
  IUpdateUserProfileData,
  IUser,
  IUserCreateForm,
  IUserSearchParams,
  IUserSignUpForm,
  IUserUpdateForm,
} from '../../../resource/user/user.types';

import * as types from './users.types';
import * as constants from './users.constants';

export const fetchUsers = (searchParams?: IUserSearchParams): types.IFetchUsers => ({
  type: constants.FETCH_USERS,
  payload: searchParams,
});

export const signUpUser = (user: IUserSignUpForm): types.ISignUpUser => ({
  type: constants.SIGNUP_USER,
  payload: user,
});

export const createUser = (user: IUserCreateForm): types.ICreateUser => ({
  type: constants.CREATE_USER,
  payload: { user },
});

export const updateUser = (userId: IUser['id'], user: IUserUpdateForm): types.IUpdateUser => ({
  type: constants.UPDATE_USER,
  payload: {
    id: userId,
    data: user,
  },
});

export const checkUserExistence = (email: string): types.ICheckUserExistence => ({
  type: constants.CHECK_USER_EXISTENCE,
  payload: { email },
});

export const storeUserExistenceCheck = (
  response: types.ICheckUserExistenceResponse,
): types.IStoreUserExistenceCheck => ({
  type: constants.STORE_USER_EXISTENCE_CHECK,
  payload: response,
});

export const clearUserExistenceCheck = (): types.IClearUserExistenceCheck => ({
  type: constants.CLEAR_USER_EXISTENCE_CHECK,
});

export const updateUserEmail = (data: IUpdateUserEmailData): types.IUpdateUserEmail => ({
  type: constants.UPDATE_USER_EMAIL,
  payload: data,
});

export const changePassword = (password: IChangePasswordUserData['password']) => ({
  type: constants.CHANGE_PASSWORD,
  payload: {
    password,
  },
});

export const deleteUser = (userId: IUser['id']): types.IDeleteUser => ({
  type: constants.DELETE_USER,
  payload: userId,
});

export const enableUser = (userId: IUser['id']): types.IEnableUser => ({
  type: constants.ENABLE_USER,
  payload: userId,
});

export const updateUserProfile = (data: IUpdateUserProfileData) => ({
  type: constants.UPDATE_USER_PROFILE,
  payload: data,
});

export const storeUsers = (Users: IUser['id'][]): types.IStoreUser => ({
  type: constants.STORE_USER,
  payload: Users,
});

export const clearUser = (): types.IClearUser => ({
  type: constants.CLEAR_USER,
});

export const storeFetchedActiveUsers = (fetchedUsers: IUser['id'][]): types.IStoreFetchedActiveUsers => ({
  type: constants.STORE_FETCHED_ACTIVE_USERS,
  payload: fetchedUsers,
});

export const clearFetchedActiveUsers = (): types.IClearFetchedActiveUsers => ({
  type: constants.CLEAR_FETCHED_ACTIVE_USERS,
});

export const storeFetchedDeletedUsers = (fetchedUsers: IUser['id'][]): types.IStoreFetchedDeletedUsers => ({
  type: constants.STORE_FETCHED_DELETED_USERS,
  payload: fetchedUsers,
});

export const clearFetchedDeletedUsers = (): types.IClearFetchedDeletedUsers => ({
  type: constants.CLEAR_FETCHED_DELETED_USERS,
});

export const storeIsFetched = (): types.IStoreIsFetched => ({
  type: constants.STORE_IS_FETCHED,
});

export const clearIsFetched = (): types.IClearIsFetched => ({
  type: constants.CLEAR_IS_FETCHED,
});

export const syncUserWithSlack = (): types.ISyncUserWithSlack => ({
  type: constants.SYNC_USER_WITH_SLACK,
});

export const createUserSuccess = (): types.ICreateUserSuccess => ({
  type: constants.CREATE_USER_SUCCESS,
});

export const clearCreateUserSuccess = (): types.IClearCreateUserSuccess => ({
  type: constants.CLEAR_CREATE_USER_SUCCESS,
});

export const addUserToTenantSuccess = (): types.IAddUserToTenantSuccess => ({
  type: constants.ADD_USER_TO_TENANT_SUCCESS,
});

export const clearAddUserToTenantSuccess = (): types.IClearAddUserToTenantSuccess => ({
  type: constants.CLEAR_ADD_USER_TO_TENANT_SUCCESS,
});
